/*
 * DISTRIBUTION STATEMENT C. Distribution authorized to U.S. Government Agencies and their contractors; Critical
 * Technology; 19 October 2017. Other requests for this document shall be referred to Chemical and Biological
 * Technologies, Defense Threat Reduction Agency, 8725 John J Kingman Road, Fort Belvoir, VA 22060-6201.
 *
 * WARNING: This document contains technical data whose export is restricted by the Arms Export Control Act (Sec 2751
 * of Title 22, United States Code) or the Export Control Reform Act of 2018 (Chapter 58 Sections 4801-4852 of Title
 * 50, United States Code). Violations of these export laws are subject to severe criminal penalties. Disseminate in
 * accordance with provisions of DoD Directive 5230.25 and DoD Instruction 2040.02. DESTRUCTION NOTICE: For
 * unclassified, limited distribution documents, destroy by any method that will prevent disclosure of the contents
 * or reconstruction of the document.
 *
 * This material is based upon work supported by the Under Secretary of War for Research and Engineering under Air
 * Force Contract No. FA8702-15-D-0001 or FA8702-25-D-B002. Any opinions, findings, conclusions or recommendations
 * expressed in this material are those of the author(s) and do not necessarily reflect the views of the Under
 * Secretary of War for Research and Engineering.
 *
 * © 2026 Massachusetts Institute of Technology.
 *
 * The software/firmware is provided to you on an As-Is basis
 *
 * Delivered to the U.S. Government with Unlimited Rights, as defined in DFARS Part 252.227-7013 or 7014 (Feb 2014).
 * Notwithstanding any copyright notice, U.S. Government rights in this work are defined by DFARS 252.227-7013 or
 * DFARS 252.227-7014 as detailed above. Use of this work other than as specifically authorized by the U.S.
 * Government may violate any copyrights that exist in this work.
 *
 * This document contains Controlled Unclassified Information (CUI). Handling of this information is subject to the
 * controls identified in DFARS 252.204-7012 - SAFEGUARDING COVERED DEFENSE INFORMATION AND CYBER INCIDENT REPORTING.
 */

import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/bootstrap_custom.scss';

import App from './App';
import Store from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <Provider store={Store}>
      <App />
    </Provider>
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
